import { useState, useEffect } from "react";
import { useSignal } from "@preact/signals-react";
// import { format } from "date-fns";

import { getStorage } from "store/local";
import BasicTable from "componentsv2/table/BasicTable";
import Button from "componentsv2/button/Button";
import DatePicker from "componentsv2/form/DatePicker";
import Text from "componentsv2/form/Text";
import Char from "componentsv2/form/Char";
import Selection from "componentsv2/form/Selection";
import { layout } from "./ModelStaffShift";
import { useWizard } from "storev2/wizardStore";
// import { useStore, insertRecord } from "storev2/formStore";
import { useTable } from "storev2/tableStore";
import {
  MessageContainer,
  useMessage,
} from "componentsv2/experimental/Message";
import proxy from "api/proxy";

const model = "staff.shift";
const method = "create_staff_access";
const layoutShift = layout();

function CreateControlAccess({ onClose, openModal }) {
  const { messages, warning, hide, success, clear, error } = useMessage();
  const notes = useSignal("");
  const shiftDate = useSignal();
  const employeeName = useSignal("");
  const type = useSignal({ id: "entry", name: "entry" });
  const [records, setRecords] = useState([]);
  const { reset } = useWizard();
  const { getTable, reload, presetTable } = useTable.getState();
  
  const storeId = "staff.shift";
  const TYPES = [
    { id: "entry", name: "entry" },
    { id: "exit", name: "exit" },
    { id: "both", name: "both" },
  ];

  // Reset state when the dialog closes
  useEffect(() => {
    presetTable(storeId, layoutShift);
    if (openModal && !openModal.value) {
      handleClose();
      clear();
    }
  }, [openModal?.value]);

  const attrsEmployees = {
    name: "employees",
    layout: layoutShift,
    selectable: "multi",
  };

  const attrsDate = {
    label: "staff.access.start_date",
    name: "start_date",
    onChange: onChange,
  };

  const attrsEmployeeName = {
    label: "staff.access.employee",
    name: "employee_name",
    onChange: onChange,
  };

  const attrsType = {
    label: "staff.access.type",
    name: "type",
    onChange: onChange,
    options: TYPES,
    translate: true,
    model: "staff.access",
  };

  const attrsNotes = {
    label: "staff.access.notes",
    name: "notes",
    onChange: onChange,
    style: "w-full",
  };

  function handleClose() {
    shiftDate.value = "";
    employeeName.value = "";
    notes.value = "";
    setRecords([]);
    onClose();
  }

  function onChange(fieldName, value) {
    if (fieldName === "start_date") {
      shiftDate.value = value;
    } else if (fieldName === "notes") {
      notes.value = value;
    } else if (fieldName === "employee_name") {
      employeeName.value = value;
    } else if (fieldName === "type") {
      type.value = value;
    }
  }

  async function handleSearch() {
    const session = await getStorage("ctxSession");
    const _date = shiftDate.value;
    console.log(_date, "_date");

    if (!_date) return;

    const basicDomain = [
      ["shift_date", "=", _date],
      ["shift_kind.mode", "!=", "rest"],
      ["section.chiefs", "=", session?.user_employee],
      ["state", "!=", "cancelled"],
    ];
    
    if (type.value.id == "exit") {
      basicDomain.push(["attendance.exit_timestamp", "=", null]);
    } else {
      basicDomain.push(["attendance", "=", null]);
    }

    if (employeeName.value) {
      basicDomain.push(["employee.rec_name", "ilike", `%${employeeName.value}%`]);
    }
    const { data: shifts, error: errShift } = await proxy.search(
      "staff.shift",
      basicDomain,
      ["id", "employee", "employee.rec_name", "employee.contracting_state", "employee.contract.finished_date"]
    );

    if (errShift) {
      console.error("Error searching shifts", errShift);
      return;
    }

    // if (!shifts || shifts.length === 0) {
    //   reload(storeId, { search: basicDomain });
    //   setRecords([]);
    //   return;
    // }

    const shiftsFinal = shifts
      .filter((s) => {
        const employee = s["employee."];
        const finishedDate = employee?.["contract."]?.finished_date;

        return (
          employee?.contracting_state === "outsourcing" ||
          !finishedDate ||
          finishedDate >= _date
        );
      })
      .map((s) => s);

    // let notEmployees = [];
    // if (regularEmployees.length > 0) {
    //   const contractDomain = [
    //     ["employee", "in", regularEmployees],
    //     ["start_date", "<=", _date],
    //     ["OR", [["employee.contract.finished_date", "=", null]], [["employee.contract.finished_date", ">=", _date]]],
    //   ];
    //   const { data: activeContracts, error: errContract } = await proxy.search(
    //     "staff.contract",
    //     contractDomain,
    //     ["employee"]
    //   );

    //   if (errContract) {
    //     console.error("Error searching contracts", errContract);
    //     return;
    //   }

    //   const activeEmployeesSet = new Set(activeContracts?.map((c) => c.employee) || []);

    //   notEmployees = regularEmployees.filter((emp) => !activeEmployeesSet.has(emp));
    // }

    // const finalDomain = [...basicDomain];
    // if (notEmployees.length > 0) {
    //   finalDomain.push(["employee", "not in", notEmployees]);
    // }

    reload(storeId, { search: [["id", "in", shiftsFinal.map((s) => s.id)]] });
    // console.log("shiftsFinal", shiftsFinal);
    // const validShifts = shifts.filter((s) => !notEmployees.includes(s.employee));
    setRecords(shiftsFinal);
  }

  async function handleCreate() {
    const selected = getTable(storeId)?.selected || new Map();
    const ids = Array.from(selected.values()).map((shift) => shift.id);

    if (ids.length === 0) return;
    const args = [ids, { notes: notes.value, 'type': type.value?.id }];
    const { error } = await proxy.methodCall({ model, method, args });

    if (error) {
      error("Error al crear registros");
      return;
    }

    success("Registros creados correctamente");

    notes.value = "";
    handleSearch();
    reset();
  }

  return (
    <div className="h-[60vh] flex flex-col relative w-full">
      <div className="flex-none mb-3 grid grid-cols-1 md:grid-cols-4 gap-3 w-full">
        <Selection
          {...attrsType}
          data={type}
          options={TYPES}
        />
        <DatePicker {...attrsDate} data={shiftDate} />
        {/* <div className="md:col-span-2"> */}
          <Char {...attrsEmployeeName} data={employeeName} />
        {/* </div> */}
        <div className="flex items-end">
          <Button
            color="green"
            content="staff.access.create_access_filter"
            style="h-10 w-full"
            onClick={handleSearch}
          />
        </div>
      </div>
      <div className="flex-1 min-h-0 flex flex-col relative w-full">
        <div className="flex-1 overflow-auto w-full mb-4">
          <BasicTable
            {...attrsEmployees}
            recordStoreId={storeId}
            storeId={storeId}
            records={records}
          />
        </div>
        <div className="flex-none w-full mt-auto flex flex-col gap-4">
          <Text {...attrsNotes} data={notes} />
          <div className="flex max-md:flex-col justify-end pt-2 items-center w-full">
            <MessageContainer
              messages={messages}
              onMessageClose={hide}
              position="top-center"
            />
            <div className="w-full md:w-auto mt-2 md:mt-0">
              <Button
                color="blue"
                content="staff.access.create_staff_assistance"
                onClick={handleCreate}
                style="w-full md:w-48"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateControlAccess;
